var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationFeaturesTab1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 536,
    height: 346,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 536,
    height: 346,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E8EAF6",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242A45",
    d: "M-3.53.197h547v59h-547z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.47 14.197)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    opacity: 0.245
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 16,
    r: 16,
    opacity: 0.104
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    opacity: 0.75,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    y: 14,
    opacity: 0.25,
    rx: 3
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 93)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 316,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 316,
    x: 295,
    fill: "#FFF",
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 78.47,
    y: 38.197,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.47 115.197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 26,
    r: 16,
    fill: "#F98E5D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 40,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 60,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 94,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 114,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 6,
    x: 284,
    y: 134,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 30,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.47 181.197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6AC6D6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.47 237.197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#A47ED4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.47 293.197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EC7878"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 6,
    x: 47,
    y: 6,
    fill: "#242A45",
    opacity: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 47,
    y: 20,
    fill: "#242A45",
    opacity: 0.25,
    rx: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationFeaturesTab1);
export default __webpack_public_path__ + "static/media/illustration-features-tab-1.0da3d302207bcad90cdadc5052e35ed6.svg";
export { ForwardRef as ReactComponent };